import fr from 'facet-rest';
import React from 'react';
import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import {
  ScenarioSelectionRedefinedPortfolioUpdatesContent,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate/Content';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  RoadmapDeliverablePortfolioUpdatesLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/RoadmapDeliverable/PortfolioUpdates/layout';
import { pick } from 'Helpers/Affordances';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { GuidedHouseholdReviewLayout } from './GuidedHouseholdReviewLayout';

const addOverrides = (baseOverrides) => baseOverrides
  .done();

const defaultMetaOverrideSet = addOverrides(buildFacetDesignOverride());
const roadmapDeliverableMetaOverrideSet = addOverrides(buildFacetDesignOverride());
const guidedHouseholdReviewMetaOverrideSet = addOverrides(buildBaseOverrides());

export const ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate = ({
  resource,
}) => {
  const layout = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: GuidedHouseholdReviewLayout,
    [fr.relationships.back.name]: RoadmapDeliverablePortfolioUpdatesLayout, // back relationship is only present for roadmap deliverable version of this page
  }, ScenarioSelectionRedefinedPortfolioUpdatesContent);
  const metaOverrideSet = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: guidedHouseholdReviewMetaOverrideSet,
    [fr.relationships.back.name]: roadmapDeliverableMetaOverrideSet, // back relationship is only present for roadmap deliverable version of this page
  }, defaultMetaOverrideSet);
  const Component = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: MetaResourceRenderer,
    [fr.relationships.back.name]: MetaResourceRenderer, // back relationship is only present for roadmap deliverable version of this page
  }, ScenarioSelectionRedefinedWrapperTemplate);

  return (
    <Component
      resource={resource}
      layout={layout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};
